import { useQueryClient, useMutation, } from "@tanstack/react-query";
import { useAuthApiClient } from "./useAuthApiClient";
import { QUERY_KEYS } from "./constants";
/**
 * This hook is not exposed for external consumers. For creating session they
 * should use `useSignIn` hook related to the authentication method.
 */
export function useCreateSession(mutationOptions = {}) {
    const queryClient = useQueryClient();
    const authApiClient = useAuthApiClient();
    const { onSuccess: customOnSuccess, ...restMutationOptions } = mutationOptions;
    const { mutate, mutateAsync, ...rest } = useMutation({
        mutationFn: (createSessionRequest) => authApiClient.createSession(createSessionRequest),
        onSuccess: (data, variables, context) => {
            // Since `getSession` query also has code in its query keys we can't set
            // query data for a specific query, because we don't know if the code was
            // used or not. Because of that we just reset all getSession queries
            queryClient.resetQueries({ queryKey: [QUERY_KEYS.SESSION] });
            queryClient.resetQueries({
                queryKey: [QUERY_KEYS.ACCOUNT, QUERY_KEYS.CURRENT],
            });
            if (customOnSuccess)
                customOnSuccess(data, variables, context);
        },
        ...restMutationOptions,
    });
    return { createSession: mutate, createSessionAsync: mutateAsync, ...rest };
}
//# sourceMappingURL=useCreateSession.js.map